import { FormBuilder } from 'reservations/form/helpers/FormBuilder';

export const cleanCreateBookingFormData = (
  formData: Record<string, any>,
  locationId: string
) => {
  const form = new FormBuilder()
    .addBookingType(formData['bookingType'])
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .addDateTime(
      formData['date'],
      formData['availability'],
      formData['bookingType']
    )
    .addPartySize(formData['partySize'])
    .addNote(formData['note'])
    //TODO: Remove this once we've fully rolled out pre-dining feature
    // as the special occasion field is omitted in that booking flow
    .addSpecialOccasion(formData['specialOccasion'])
    .addMarketingOptIn(
      formData['optInMarketingEmail'],
      formData['optInMarketingSms']
    )
    .addPaymentMethod(
      formData['savedPaymentMethod'],
      formData['token'],
      formData['cardDetails']
    )
    .addLocation(locationId)
    .build();
  return form;
};

export function cleanUpdateBookingFormData(formData: Record<string, any>) {
  const form = new FormBuilder()
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .addDateTime(formData['date'], formData['availability'])
    .addPartySize(formData['partySize'])
    .addNote(formData['note'])
    .addSpecialOccasion(formData['specialOccasion'])
    .build();
  return form;
}

export function cleanUpdateBookingFormDataV2(formData: Record<string, any>) {
  const form = new FormBuilder()
    .addBookingType(formData['bookingType'])
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .addDateTime(formData['date'], formData['availability'])
    .addPartySize(formData['partySize'])
    .addNote(formData['note'])
    .addSpecialOccasion(formData['specialOccasion'])
    .addPaymentMethod(
      formData['savedPaymentMethod'],
      formData['token'],
      formData['cardDetails']
    )
    .build();
  return form;
}

export const cleanJoinBookingFormData = (formData: Record<string, any>) => {
  const form = new FormBuilder()
    .addName(formData['name'])
    .addEmail(formData['email'])
    .addPhoneNumber(formData['phone'], formData['phoneCode'])
    .build();

  return form;
};

export const cleanChecklessFormData = (formData: Record<string, any>) => {
  const form = new FormBuilder()
    .addPaymentMethod(
      formData['savedPaymentMethod'],
      formData['token'],
      formData['cardDetails']
    )
    .addChecklessPayments(formData['tipPercentage'])
    .build();
  return form;
};

export const cleanGuestsFormData = (formData: Record<string, any>) => {
  const form = new FormBuilder().addGuests(formData['guests']).build();
  return form;
};
